
<div class="modal-header">
    <h4 class="modal-title pull-left">{{ action === 'add' ? ('GLOBAL.ADD_USERS_TO_SITE' | translate) : ('GLOBAL.DELERE_USERS_FROM_SITE' | translate) }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
        <span aria-hidden="true">&times;</span>
    </button>
</div>


<div class="modal-body">
    <form #form  id="myForm" (ngSubmit)="onSubmit()">

        <div class="form-group">
            <label for="siteName">{{'GLOBAL.SITE' | translate}}</label>
            <input id="siteName" type="text" [disabled]="true" [ngModel]="userService.currentSite()?.nom" name="siteName" class="form-control" placeholder="{{'REFERENTIEL_UTILISATEUR.ADRESSE_MAIL' | translate}}" maxlength="256" required />
        </div>


        <div class="form-group">
            <label for="selectSites">{{'GLOBAL.UTILISATEURS' | translate}}</label>
            <ng-select [items]="tabUtilisateurs()"
                       [multiple]="true"
                       [closeOnSelect]="false"
                       bindLabel="email"
                       placeholder="Users"
                       name="selectUsers"
                       id="selectUsers"
                       [clearSearchOnAdd]="true"
                       [compareWith]="compareFunction"
                       [(ngModel)]="userSelectionnes"
                       class="custom"
                       groupBy="groupByNomRegion">
            </ng-select>
        </div>

        <div class="btn-toolbar justify-content-between">
            <div class="btn-group" role="group">
                <button type="submit" class="btn btn-outline-success">{{ action === 'add' ? ('GLOBAL.AJOUTER' | translate) : ('GLOBAL.SUPPRIMER' | translate) }}</button>
            </div>
            <div class="btn-group" role="group">
                <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
            </div>
        </div>

    </form>

</div>







